export default "__VITE_ASSET__BjpUkcYS__"